import React, { useState, useEffect } from 'react';
import "../../pages/styles/SelectSearch.css";

function ItemPicker({ onChange }) {
    const [items, setItems] = useState([]);
    const [descripcion, setDescripcion] = useState("");
    const [unidadesMedida, setUnidadesMedida] = useState([]);
    const [unidadMedida, setUnidadMedida] = useState(58);
    const [codigo, setCodigo] = useState("I00001");
    useEffect(() => {
        fetchUnidadesMedida();
    }, []);

    useEffect(() => {
        onChange(items);
    }, [items]);

    const fetchUnidadesMedida = async () => {
        const req = await fetch(`/api/productos/unidades`);
        const data = await req.json();
        setUnidadesMedida(data.respuesta);
    }

    const onAddItem = () => {
        if (!unidadMedida) {
            alert("Debe seleccionar una unidad de medida.");
            return;
        }

        if (!codigo || codigo.trim().length < 3) {
            alert("El código debe tener al menos 3 caracteres.");
            return;
        }

        if (!descripcion || descripcion.trim().length < 3) {
            alert("La descripción debe tener al menos 3 caracteres.");
            return;
        }

        const newItem = {
            codigo: codigo,
            descripcion: descripcion,
            unidadMedida: unidadMedida,
            cantidad: 1,
            observacion: ""
        };
        setItems([...items, newItem]);
        setDescripcion("");
        setUnidadMedida(58);
        setCodigo("I0000" + (items.length + 2));
    }

    return (
        <div>
            <div className="caja-fondo-blanco-m-2">
                <b className="pt-3 mb-3">Agregar items </b> <br />
                <div className="row">
                    <div className="col-12 col-md-2">
                        <div className="form-group mt-3">
                            <label htmlFor="companyName">Código</label>
                            <div className="input__Almacen">
                                <input
                                    name="Codigo"
                                    className="input__linea"
                                    type="text"
                                    placeholder="Código"
                                    autoComplete="off"
                                    value={codigo}
                                    onChange={(e) => setCodigo(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-10">
                        <div className="form-group mt-3">
                            <label htmlFor="companyName">Descripción</label>
                            <div className="input__Almacen">
                                <input
                                    name="Descripcion"
                                    className="input__linea"
                                    type="text"
                                    placeholder="Descripción"
                                    autoComplete="off"
                                    value={descripcion}
                                    onChange={(e) => setDescripcion(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="form-group mt-3">
                            <label htmlFor="companyName">Unidad de Medida</label>
                            <div className="input__Almacen">
                                <select className="form-control form-control-sm input__linea" value={unidadMedida} onChange={(e) => setUnidadMedida(e.target.value)}>
                                    {unidadesMedida.map(um => (
                                        <option key={um.IdUnidad} value={um.IdUnidad}>{um.Descripcion} ({um.Codigo})</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 justify-content-end d-flex">
                        <button className="btn btn-verde-mfp-letra-normal rounded-0" onClick={onAddItem}>
                            Agregar
                        </button>
                    </div>
                </div>
            </div>
            <table className="table table-hover text-center">
                <thead className="text-center bg-dark text-white">
                    <tr>
                        <th className="col-1">#</th>
                        <th className="col-1">Código</th>
                        <th className="col-6">Descripción</th>
                        <th className="col-1">Cantidad</th>
                        <th className="col-2">Observación</th>
                        <th className="col-1">Acción</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => (
                        <tr key={item.value}>
                            <td>{index + 1}</td>
                            <td>{item.codigo}</td>
                            <td>{item.descripcion}</td>
                            <td>
                                <input type="number" className="form-control form-control-sm input__linea" value={item.cantidad} onChange={(e) => setItems(items.map(i => i.value === item.value ? { ...i, cantidad: e.target.value } : i))} />
                            </td>
                            <td>
                                <input type="text" className="form-control form-control-sm input__linea" value={item.observacion} onChange={(e) => setItems(items.map(i => i.value === item.value ? { ...i, observacion: e.target.value } : i))} />
                            </td>
                            <td>
                                <button className="btn btn-danger" onClick={() => setItems(items.filter(i => i.codigo !== item.codigo))}><i className="fa fa-trash"></i></button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default ItemPicker;